import React from 'react';
import { ThreeDots } from 'react-loader-spinner';

export default function ThreeDotsBlackLoader() {
    return <ThreeDots wrapperStyle={{ display: ''}} color="#3333330" height={16} width={40} />
}
